function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable no-await-in-loop */
const processState = async (state, evaluator) => {
  if (!state) {
    return null;
  }
  const result = await evaluator(state.test);
  return result;
};

/**
  * @function evalute - evaluate stateMachineBehavior
  */
const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions, evaluator) => {
  const {
    stateIdentifier: unevaluatedStateIdentifier,
    states: originalStates = [],
    initialState: unevaluatedInitialState,
    auto: unevaluatedAuto
  } = source;
  const stateIdentifier = await evaluator(unevaluatedStateIdentifier);
  const auto = await evaluator(unevaluatedAuto);
  const initialState = await evaluator(unevaluatedInitialState);
  if (!stateIdentifier && initialState) {
    return initialState;
  }
  const states = JSON.parse(JSON.stringify(originalStates));
  const currentStates = [];
  for (let i = 0; i < states.length; i += 1) {
    const state = states[i];
    const identifier = await evaluator(state.identifier);
    if (identifier === stateIdentifier) {
      currentStates.push(state);
    }
  }
  if (currentStates.length === 0) {
    // State identifier is not present in state machine
    return stateIdentifier;
  }
  let nextIdentifier;
  for (let i = 0; i < currentStates.length; i += 1) {
    const currentState = currentStates[i];
    const {
      nextState: {
        identifier: unevaluatedNextStateIdentifier
      } = {}
    } = currentState;
    const result = await processState(currentState.nextState, evaluator);
    if (result) {
      const nextStateIdentifier = await evaluator(unevaluatedNextStateIdentifier);
      nextIdentifier = nextStateIdentifier;
      break;
    }
  }
  if (!nextIdentifier) {
    return stateIdentifier;
  }
  // Should check to see if the next identifier is skippable
  if (auto) {
    return evaluator(_objectSpread(_objectSpread({}, source), {}, {
      stateIdentifier: nextIdentifier
    }));
  }
  return nextIdentifier;
};
module.exports = {
  evaluate
};